<div id="faqPageContainer">
     <section class="bg-light" id="main">
          <div class="container">
               <div class="d-flex justify-content-between align-items-center" id="page-title">
                    <h1 [innerHtml]="'FrequentlyAskedQuestions' | translator:'base'">Frequently Asked Questions</h1>
               </div>
               <div *ngIf="previewItemId" class="alert alert-warning" role="alert">
                    <h2>Preview Mode</h2>
               </div>
               <div class="row">
                    <div class="col-lg-4 order-lg-2 sidebar">
                         <div class="card shadow-sm rounded-0 border-0">
                              <div class="card-body">
                                   <h2 class="h5" [innerHtml]="'FrequentlyAskedQuestions' | translator:'base'">Search and Filter
                                   </h2>
                                   <p [innerHtml]="'FAQSearchByKeyword' | translator:'base'">Search by keyword or use
                                        the filters below to find the answers to your questions.</p>
                                   <div class="mb-3">
                                        <label for="filter-query" class="sr-only"
                                             [innerHtml]="'faq-keyword' | translator:'base'">FAQ&nbsp;Search</label>
                                        <div class="input-group">
                                             <input type="text" class="form-control rounded-0" id="filter-query"
                                                  [(ngModel)]="searchTxt" (keyup)="testRow()"
                                                  [placeholder]="'faq-keyword' | translator:'base'" name="filter-query">
                                             <div class="input-group-append">
                                                  <button class="btn btn-outline-primary btn-brand"
                                                       (click)="clearSearchText();" *ngIf="showFAQs === 'search'"
                                                       [title]="'faq-clear-filter' | translator:'base'">
                                                       <i class="fas fa-times"></i>
                                                       <span [innerHtml]="'faq-clear-filter' | translator:'base'" 
                                                       class="sr-only" [title]="'faq-clear-filter' | translator:'base'"></span>
                                                  </button>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="filters">
                                        <h3 class="text-brand-dark h6 mb-1"
                                             [innerHtml]="'faq-by-user' | translator:'base'"
                                             *ngIf="(userFilterSet.length > 0 || topicFilterSet.length > 0)">Filter by
                                             User</h3>
                                        <h3 class="text-brand-dark h6 mb-1"
                                             [innerHtml]="'faq-by-user' | translator:'base'"
                                             *ngIf="!(userFilterSet.length > 0 || topicFilterSet.length > 0)">Filter by
                                             User</h3>
                                        <div class="" *ngFor="let user of userFilterToDisplay; let userIndex = index">
                                             <div class="form-check">
                                                  <label class="form-check-label mb-0"
                                                       *ngIf="selectedLanguage === 'en'">
                                                       <input type="checkbox" [id]="'stakeholder_' + userIndex"
                                                            [name]="'stakeholder_' + userIndex"
                                                            [checked]="testUser(user)"
                                                            (click)="filterUser(user)" class="form-check-input" />
                                                       {{ user }}<span class="count"> ({{ getCountUser(user) }})</span>
                                                  </label>
                                                  <label class="form-check-label mb-0" *ngIf="selectedLanguage === 'fr'">
                                                       <input type="checkbox" :id="('stakeholder_') + userIndex"
                                                       [name]="('stakeholder_') + userIndex"
                                                            [checked]="testUser(user)"
                                                            (click)="filterUser(user)" class="form-check-input" />
                                                       {{user}}<span class="count"> ({{getCountUser(user)}})</span>
                                                  </label>
                                                  <label class="form-check-label mb-0" *ngIf="selectedLanguage === 'es'">
                                                       <input type="checkbox" :id="('stakeholder_') + userIndex"
                                                            [name]="('stakeholder_') + userIndex"
                                                            [checked]="testUser(user)"
                                                            (click)="filterUser(user)" class="form-check-input" />
                                                       {{user}}<span class="count"> ({{getCountUser(user)}})</span>
                                                  </label>
                                             </div>
                                        </div>
                                        <h3 class="text-brand-dark h6 mt-3 mb-1" [innerHtml]="'faq-by-topic' | translator:'base'">Filter by Topic</h3>
                                        <div class=""
                                             *ngFor="let topic of topicFilterToDisplay; let topicIndex = index">
                                             <div class="form-check">
                                                  <label class="form-check-label mb-0"
                                                       *ngIf="selectedLanguage === 'en'">
                                                       <input type="checkbox" [id]="'topic_' + topicIndex"
                                                            [name]="'topic_' + topicIndex"
                                                            [checked]="topicFilterSet.includes(topic)"
                                                            (click)="filterTopic(topic)" [value]="topic"
                                                            class="form-check-input" />
                                                       {{ topic }}<span class="count"> ({{
                                                            getCountTopic(topic) }})</span>
                                                  </label>
                                                  <label class="form-check-label mb-0" *ngIf="selectedLanguage === 'fr'">
                                                       <input type="checkbox" :id="('topic_') + topicIndex"
                                                            [name]="('topic_') + topicIndex"
                                                            [checked]="topicFilterSet.includes(topic)"
                                                            (click)="filterTopic(topic)" :value="topic"
                                                            class="form-check-input" />
                                                       {{topic}}<span class="count">
                                                            ({{getCountTopic(topic)}})</span>
                                                  </label>
                                                  <label class="form-check-label mb-0" *ngIf="selectedLanguage === 'es'">
                                                       <input type="checkbox" :id="('topic_') + topicIndex"
                                                            [name]="('topic_') + topicIndex"
                                                            [checked]="topicFilterSet.includes(topic)"
                                                            (click)="filterTopic(topic)" :value="topic"
                                                            class="form-check-input" />
                                                       {{topic}}<span class="count">
                                                            ({{getCountTopic(topic)}})</span>
                                                  </label>
                                             </div>
                                        </div>
                                        <button type="button" (click)="resetCheckboxFilters();"
                                             class="btn btn-primary btn-sm filter-clear mt-3"
                                             *ngIf="(userFilterSet.length > 0 || topicFilterSet.length > 0)"
                                             [title]="'faq-reset' | translator:'base'">
                                             Reset filters
                                        </button>
                                   </div>
                                   <p class="mt-3" [innerHtml]="'FAQSomeMay' | translator:'base'">Some FAQs contain
                                        links to PDF documents. You can download a free PDF viewer below.</p>
                                   <p>
                                        <a href="http://get.adobe.com/reader/"
                                             class="btn btn-outline-primary btn-sm btn-brand" target="_blank"
                                             rel="noopener noreferrer" role="button"
                                             [innerHtml]="'DownloadPDFButtonText' | translator:'base'">Download a free
                                             PDF viewer (new window)</a>
                                   </p>
                              </div>
                         </div>
                    </div>
                    <div class="col-lg-8">
                         <p>
                              <span [innerHtml]="'faq-title-subheader-1' | translator:'base'">
                                   Use the filters or search by keyword below to find the answers to your questions. If
                                   you can't find what you're looking for,
                              </span>
                              <a routerLink="/customerSupport" (click)="scrollToTop()"
                                   [innerHtml]="'faq-title-subheader-2' | translator:'base'"  
                                   [title]="'faq-title-subheader-2' | translator:'base'">
                                   <span>contact
                                        the PSP Customer Service team</span>
                              </a>
                              <span [innerHtml]="'faq-title-subheader-3' | translator:'base'">to get help.</span>
                         </p>
                         <h2 class="h4" *ngIf="showFAQs === '10'" [innerHtml]="'faq-search-10' | translator:'base'">Top
                              10 Frequently Asked Questions</h2>
                         <h2 class="h4" *ngIf="showFAQs === 'All'" [innerHtml]="'faq-search-All' | translator:'base'">
                              All FAQs</h2>
                         <h2 class="h4" *ngIf="showFAQs === 'search'"
                              [innerHtml]="'faq-search-results' | translator:'base'">Search Results</h2>
                         <div id="accordion" class="accordion">
                              <div class="faq-filter-no-results"
                                   [style]="showNoFAQs() ? {'display':'block'} : {'display':'none'}">
                                   <p>
                                        <em [innerHtml]="'faq-nothing' | translator:'base'">Nothing FAQs found.</em>
                                   </p>
                              </div>
                              <div id="faq-list" ngbAccordion [closeOthers]="true"
                                   *ngIf="faqsToDisplay && faqsToDisplay.length > 0 || searchTxt === '' || showNoFAQs()">
                                   <div ngbAccordionItem *ngFor="let faq of faqsToDisplay; let faqIndex = index"
                                        [collapsed]="(faqsToDisplay.length === 1 ? false : true)"
                                        [id]="'faq-' + faq.index" [attr.data-topics]="faq.tags"
                                        [attr.data-users]="faq.stakeHolders">
                                        <h2 ngbAccordionHeader 
                                             class="accordion-header h6" 
                                             [id]="'faq-heading-' + faq.index">
                                             <button ngbAccordionButton 
                                                  (click)="setOn(faq.index)" [id]="'faq-content-btn' + faq.index"
                                                  [name]="'faq-content-btn' + faq.index" 
                                                  [attr.data-bs-target]="'#faq-content-' + faq.index"
                                                  aria-expanded="false"
                                                  [attr.aria-controls]="'faq-content-' + faq.index">{{faq.question}}</button>
                                        </h2>
                                        <div ngbAccordionCollapse [id]="'faq-content-'+faq.index"
                                             
                                             [attr.aria-labelledby]="'faq-heading-'+faq.index" role="region">
                                             <div ngbAccordionBody class="accordion-body">
                                                  <p [innerHtml]="faq.answer"></p>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              
                         </div>
                         <div class="container">
                              <div class="row mt-3">
                                   <div class="col-12 mb-3 mb-lg-0 psp-faq-btn">
                                        <span class="" *ngIf="showFAQs === '10' || showFAQs === 'search'">
                                             <button class="btn btn-primary d-flex align-items-center" (click)="showAllSearch()"
                                                  id="showAll" name="showAll" [title]="'faq-view-all' | translator:'base'"
                                                  [innerHtml]="'faq-view-all' | translator:'base'" >View all
                                                  FAQs
                                             </button>
                                        </span>
                                        <span class="" *ngIf="showFAQs === 'All'">
                                             <button class="btn btn-primary d-flex align-items-center" (click)="showTop10()"
                                                  [title]="'faq-show-10' | translator:'base'"
                                                  [innerHtml]="'faq-show-10' | translator:'base'" id="showTopTen"
                                                  name="showTopTen">Show top 10 FAQs
                                             </button>
                                        </span>
                                        <span
                                             *ngIf="faqsToDisplay && faqsToDisplay.length > 10" 
                                             class="px-2 psp-scroll-to-top-btn"
                                        >
                                             <app-scroll-to-top></app-scroll-to-top>
                                        </span> 
                                   </div> 
                              </div>
                         </div>
                         <div class="overlay" *ngIf="loading">
                              <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
                         </div>
                    </div>
               </div>
          </div>
     </section>
     <section class="text-white bg-brand" id="help-footer">
          <div class="container">
               <div class="row d-flex align-items-center">
                    <div class="col-lg-8">
                         <h2 class="text-white h4" [innerHtml]="'faq-more' | translator:'base'">Have More Questions?
                         </h2>
                         <p [innerHtml]="'faq-more-text' | translator:'base'">
                              The PSP customer service team is available Monday through Thursday from 8 AM to 6 PM ET,
                              and on Friday from 8 AM to 5 PM ET.
                              To chat with an online representative, click the "LIVE HELP" button in the top-right
                              corner of this page. You can also call us toll-free at
                              <strong>1-877-642-9499</strong> or <a class="underline"
                                   href="mailto:PSPhelp@tylertech.com">email us</a>.
                         </p>
                    </div>
                    <div class="col-lg-4 py-3">
                    </div>
               </div>
          </div>
     </section>
</div>